import { render, staticRenderFns } from "./book.vue?vue&type=template&id=4fe38db4&scoped=true"
import script from "./book.vue?vue&type=script&lang=js"
export * from "./book.vue?vue&type=script&lang=js"
import style0 from "./book.vue?vue&type=style&index=0&id=4fe38db4&prod&scoped=true&lang=css"
import style1 from "./book.vue?vue&type=style&index=1&id=4fe38db4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe38db4",
  null
  
)

export default component.exports